import { ProjectTheme } from '../enums/project.enum';
import { TProjectTheme } from '../types/theme.type';

const commonTextStyle = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontUrl:
    'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  opacity: 1,
};

const baseTheme: Omit<TProjectTheme, 'modeTheme'> = {
  tab: {
    activeTab: '#FDFDFD',
    activeTabOpacity: 1,
    inactiveTab: '#FDFDFD',
    inactiveTabOpacity: 0.35,
  },
  theme: {
    bgColorButton: {
      primary: '#890096', // Safemoon brand purple
      primaryOpacity: 1,
      secondary: '#259B91', // Safemoon secondary/green
      secondaryOpacity: 1,
    },
    background: {
      color: '#14141A', // Dark background from Figma
      colorOpacity: 1,
      image: undefined,
      imageOpacity: 1,
    },
    container: {
      color: '#FDFDFD',
      colorOpacity: 0.12, // Container background with transparency
    },
    headerRow: {
      color: '#FDFDFD',
      colorOpacity: 0.12, // Header row background
    },
    referralHeroSection: {
      color: '#FDFDFD',
      colorOpacity: 0.12, // Referral hero section background
    },
  },
  components: {
    cornerRadius: 4, // 4px border radius from Figma
  },
  text: {
    heading: {
      ...commonTextStyle,
      color: '#FDFDFD', // White text for dark theme
      fontWeight: 600,
    },
    paragraph: {
      ...commonTextStyle,
      color: '#FDFDFD',
      fontWeight: 400,
    },
    subText: {
      ...commonTextStyle,
      color: '#FDFDFD59', // White with ~35% opacity
      fontWeight: 300,
    },
  },
  image: {
    logo: undefined,
    favicon: undefined,
    featureImage: undefined,
  },
};

// Light theme variant (less ommon for Safemoon)
export const lightTheme: TProjectTheme = {
  ...baseTheme,
  modeTheme: ProjectTheme.LIGHT,
  tab: {
    activeTab: '#050505',
    activeTabOpacity: 1,
    inactiveTab: '#050505',
    inactiveTabOpacity: 0.2,
  },
  theme: {
    bgColorButton: {
      primary: '#890096',
      primaryOpacity: 1,
      secondary: '#259B91',
      secondaryOpacity: 1,
    },
    background: {
      color: '#FFFFFF',
      colorOpacity: 1,
      image: undefined,
      imageOpacity: 1,
    },
    container: {
      color: '#050505',
      colorOpacity: 0.06,
    },
    headerRow: {
      color: '#050505',
      colorOpacity: 0.06,
    },
    referralHeroSection: {
      color: '#FFFFFF',
      colorOpacity: 1,
    },
  },
  text: {
    heading: {
      ...commonTextStyle,
      color: '#050505', // Dark text for light theme
      fontWeight: 600,
    },
    paragraph: {
      ...commonTextStyle,
      color: '#050505',
      fontWeight: 400,
    },
    subText: {
      ...commonTextStyle,
      color: '#05050533', // Dark text with ~20% opacity
      fontWeight: 300,
    },
  },
};

// Dark theme variant (primary Safemoon theme)
export const darkTheme: TProjectTheme = {
  ...baseTheme,
  modeTheme: ProjectTheme.DARK,
  tab: {
    activeTab: '#FDFDFD',
    activeTabOpacity: 1,
    inactiveTab: '#FDFDFD',
    inactiveTabOpacity: 0.35,
  },
  theme: {
    bgColorButton: {
      primary: '#890096',
      primaryOpacity: 1,
      secondary: '#259B91',
      secondaryOpacity: 1,
    },
    background: {
      color: '#14141A',
      colorOpacity: 1,
      image: undefined,
      imageOpacity: 1,
    },
    container: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
    headerRow: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
    referralHeroSection: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
  },
  text: {
    heading: {
      ...commonTextStyle,
      color: '#FDFDFD', // White text for dark theme
      fontWeight: 600,
    },
    paragraph: {
      ...commonTextStyle,
      color: '#FDFDFD',
      fontWeight: 400,
    },
    subText: {
      ...commonTextStyle,
      color: '#FDFDFD59', // White with ~35% opacity
      fontWeight: 300,
    },
  },
};

export const themeMap: Record<ProjectTheme, TProjectTheme> = {
  [ProjectTheme.LIGHT]: lightTheme,
  [ProjectTheme.DARK]: darkTheme,
};
